import React from 'react';

export const youtubeIcon = ({ ariaLabel = 'YouTube' }) => {
  return (
    <img
      src="/static/icon-youtube.png"
      alt={ariaLabel}
      width="24"
      height="24"
      style={{ display: 'block' }}
    />
  );
};
